import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { MobXProviderContext } from 'mobx-react';
import { stores } from './stores/RootStore';
import { ThemeProvider } from '@mui/material/styles';
import configureTheme from './styles/configureTheme';
import { ConfirmProvider } from 'material-ui-confirm';

const theme = configureTheme();
const root = document.getElementById('root');
if (root) {
	ReactDOM.createRoot(root).render(
		<React.StrictMode>
			<MobXProviderContext.Provider value={stores}>
				<ThemeProvider theme={theme}>
					<ConfirmProvider
						defaultOptions={{
							confirmationButtonProps: { autoFocus: true, variant: "contained", color: "primary" },
						}}>

						<App />
					</ConfirmProvider>
				</ThemeProvider>
			</MobXProviderContext.Provider>
		</React.StrictMode >
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
